import { types } from 'mobx-state-tree';

import QUOTE_STATUSES from '../definitions/QuoteStatus';


//TODO: Add in version id for profile service to start versioning
const Quote = types
    .model('Quote', {
        id: types.identifier,

        quoteId: types.string,
        brokerId: types.maybeNull(types.string),
        insurerId: types.string,

        yearlyRate: types.number,
        monthlyRate: types.number,
        termInMonths: types.number,

        status: types.optional(
            types.enumeration(Object.values(QUOTE_STATUSES)),
            QUOTE_STATUSES.READY,
        ),
        extraData: types.map(
            types.maybeNull(
                types.union(
                    types.string,
                    types.number,
                ),
            ),
        ),
    })
    .views(self => ({
        get hasFulfillmentUrl() {
            return self.extraData.has('fulfillmentUrl');
        },
        get fulfillmentUrl() {
            return self.extraData.get('fulfillmentUrl');
        },
    }))
    .actions(self => ({
        setFulfillmentUrl(url) {
            self.extraData.set('fulfillmentUrl', url);
        },
        setStatus(status) {
            self.status = status;
        },
    }));

export default Quote;
